import { ResetPasswordPage as SharedResetPasswordPage } from '@remote-medium/ui';

import { authClient } from '../../lib/auth.ts';
import { SITE_ORIGIN } from '../../lib/config.ts';

// The invite link is a reset-password token; the first password accepts it.
export function AcceptInvitePage() {
  return (
    <SharedResetPasswordPage
      siteUrl={SITE_ORIGIN}
      variant="invite"
      resetPassword={(newPassword, token) => authClient.resetPassword({ newPassword, token })}
    />
  );
}
